import type { AppVueRouter } from '@modules/core/services/router/types';
import type { TranslationKeysMapper } from '@modules/i18n/types';
import type { AppMenu } from '@modules/sidebar/utils';
import { AffBalancesWithdrawalModule } from '@modules/aff-balances/submodules/withdrawal/AffBalancesWithdrawalModule';
import { AppModule } from '@modules/core/plugins/AppModule';
import { useI18n } from '@modules/i18n/composables';
import {
  AFFILIATE_REPORTS_MENU_ITEM,
  TRANSLATION_GROUP_SIDEBAR,
} from '@modules/sidebar/constants';

import {
  AFF_BALANCES_PERMISSIONS,
  AFFILIATE_BALANCES_LIST_ROUTE_NAME,
  AFFILIATE_BALANCES_ROUTE_NAME,
  TRANSLATION_GROUP_AFF_BALANCES,
} from './constants';
import { getTranslationKeys } from './translations';

export class AffBalancesModule extends AppModule {
  protected submodules = [
    new AffBalancesWithdrawalModule(),
  ];

  addRoutes(router: AppVueRouter): void {
    router.addAffiliateRoute({
      name: AFFILIATE_BALANCES_ROUTE_NAME,
      path: 'balance',
      permission: AFF_BALANCES_PERMISSIONS.SHOW,
      component: () => import('@modules/core/components/SimpleChildRoutePage/SimpleChildRoutePage.vue'),
      keepAliveInclude: 'AffBalancesListPage',
    });

    router.addChildRoute(AFFILIATE_BALANCES_ROUTE_NAME, {
      name: AFFILIATE_BALANCES_LIST_ROUTE_NAME,
      path: '',
      permission: AFF_BALANCES_PERMISSIONS.SHOW,
      component: () => import('./pages/AffBalancesListPage/AffBalancesListPage.vue'),
    });
  }

  addMenu(menu: AppMenu): void {
    const { getTPath } = useI18n();

    menu.addChildAffiliateMenuItem(AFFILIATE_REPORTS_MENU_ITEM, {
      caption: getTPath(TRANSLATION_GROUP_SIDEBAR, 'REPORTS_AFFILIATE_BALANCE'),
      to: {
        name: AFFILIATE_BALANCES_LIST_ROUTE_NAME,
      },
      permission: AFF_BALANCES_PERMISSIONS.SHOW,
      id: AFFILIATE_BALANCES_LIST_ROUTE_NAME,
      order: 50,
    });
  }

  addTranslationKeys(mapper: TranslationKeysMapper): void {
    mapper.addTranslationsMap(TRANSLATION_GROUP_AFF_BALANCES, getTranslationKeys);
  }
}
